<template>
  <div
      class="trustpilot-widget"
      :class="tpClass"
      data-locale="nl-NL"
      data-template-id="5419b732fbfb950b10de65e5"
      data-businessunit-id="600025eba3f05d00013796c3"
      data-style-height="24px"
      data-style-width="100%"
      data-theme="light"
      data-tags="SelectedReview"
  >
    <a
        href="https://nl.trustpilot.com/review/bistroo.nl"
        target="_blank"
        rel="noopener"
    >Trustpilot
    </a>
  </div>
</template>

<script>
export default {
  props: {
    align: {
      type: String,
      default: 'center',
    },
  },
  computed: {
    tpClass() {
      return 'trustpilot-widget--' + this.align
    },
  },
}
</script>

<style lang="scss" scoped>
.trustpilot-widget {
  &--left {
    transform: translateY(-50%);
  }
}
</style>
